const debugLog = (...args: Array<any>) => {
  if (process.env.REACT_APP_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.log(...args)
  }
}

export default debugLog
